module.exports = __webpack_public_path__ + "static/media/mail.7ec1dac0.svg";